import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import MomentPropTypes from "../../helpers/MomentPropTypes";

import BaseModal from '../general/BaseModal';
import Calendar from './Calendar';
import PureRenderCmponent from '../PureRenderComponent';


class DateModal extends PureRenderCmponent {

    static propTypes = {
        show: PropTypes.bool.isRequired,
        onCancel: PropTypes.func,
        onSelect: PropTypes.func,
        min: MomentPropTypes.isMoment,
        max: MomentPropTypes.isMoment,
        selected: MomentPropTypes.isMoment,
        modalTitle: PropTypes.string
    };

    static defaultProps = {
        onCancel: _.noop,
        onSelect: _.noop
    };

    state = {
        selected: this.props.selected
    };

    _handleDateChange = (date) => {
        this.setState({ selected: date });
    };

    _handleSelect = () => {
        this.props.onSelect(this.state.selected);
    };

    render () {
        const calendarProps = Object.assign({},
            _.omit(this.props, [ 'onSelect', 'onCancel' ] )
        );

        return (
            <BaseModal
                show={ this.props.show }
                onContinue={ this._handleSelect }
                onClose={ this.props.onCancel }
                closeText={ "button.text.cancel" }
                continueText={ "button.text.select" }
                titleText={ this.props.modalTitle }
                className="modal--sm datetime__modal"
                disableContinue={ !this.state.selected }
            >

                <Calendar
                    { ...calendarProps }
                    onChange={ this._handleDateChange }
                    className="timeband__calendar "
                    selected={ this.state.selected }
                />
            </BaseModal>
        );
    }

}


export default DateModal;



// WEBPACK FOOTER //
// ./src/components/form/DateModal.js